import { useState, useEffect, useRef } from 'react'
import './style.css'

function Frase({frases}) {
    const [txt, setTxt] = useState(frases[0])
    const [visivel, setVisivel] = useState(true)
    const frasesRef = useRef(frases)

    useEffect(() => {
        frasesRef.current = frases
    }, [frases])

    useEffect(() => {
        const intervalo = setInterval(() => {
            setVisivel(false)

            setTimeout(() => {
                const lista = frasesRef.current
                setTxt(lista[Math.floor(Math.random() * lista.length)])
                setVisivel(true)
            }, 500)

        }, 5000)

        return () => clearInterval(intervalo)
    }, [])

    return (
        <div className="dyDivFrase">
            <p className={`dyPFrase ${visivel ? 'visivel' : 'invisivel'}`}>{txt}</p>
        </div>
    )
}

export default Frase